const REST_STATES = {
    PREPARED: 0,
    LOADING: 1,
    COMPLETED: 2,
    FAILED: 3
};

export default REST_STATES;